import { Link } from "react-router-dom";
import "./PanierCommercial.css";
import { useState, useEffect } from "react";
import PanierChrono from "../../../components/PanierChrono";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import axios from "axios";
import defaultImg from "../../Admin/IMG/1.png";

interface Product {
  id: number;
  IdArticle: number;
  RefArticle: string;
  Designation: string;
  Image: string;
  price: string;
  quantity: number;
  NomMagasin: string;
}

export default function PanierCommercial() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const MagasinId = localStorage.getItem("CommercialId");
  const [Totale, setTotale] = useState<number>(0);
  const [message, setMessage] = useState("");
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [clearingCart, setClearingCart] = useState(false);

  /* ── Fetch panier from backend ── */
  const fetchPanier = async () => {
    if (!MagasinId) return;
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/panier/visiteur/${MagasinId}/commercials`
      );
      setProducts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching panier:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPanier();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ── Delete single item ── */
  const handleDeleteProduct = async (id: number) => {
    setDeletingId(id);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete`, { id });
      await fetchPanier();
      if (products.length === 1) {
        localStorage.removeItem('cartExpiration');
      }
      window.dispatchEvent(new Event("panier-updated"));
    } catch (error) {
      console.error("Error deleting item:", error);
    } finally {
      setDeletingId(null);
    }
  };

  /* ── Clear entire panier ── */
  const hundelVidePanier = async () => {
    if (!MagasinId) return;
    setClearingCart(true);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete/all/${MagasinId}`);
      setProducts([]);
      localStorage.removeItem('cartExpiration');
      setMessage("Panier vidé avec succès !");
      setTimeout(() => setMessage(""), 3000);
      window.dispatchEvent(new Event("panier-updated"));
    } catch (error) {
      console.error("Error clearing panier:", error);
    } finally {
      setClearingCart(false);
    }
  };

  /* ── Recalculate total ── */
  useEffect(() => {
    let total = 0;
    for (let i = 0; i < products.length; i++) {
      total += Number(products[i].price) * Number(products[i].quantity);
    }
    setTotale(total);
  }, [products]);

  const handleGoBack = () => window.history.back();

  const hasProducts = products && products.length > 0;

  return (
    <>
      <NewSidebareCommercial />
      <PanierChrono />

      <div className="pc-wrapper">
        <div className="pc-inner">
          {/* ── Header ── */}
          <div className="pc-header">
            <div className="pc-header-left">
              <button className="pc-back-btn" onClick={handleGoBack}>
                <i className="bi bi-arrow-left"></i>
              </button>
              <h1 className="pc-title">
                <span className="pc-title-accent"></span>
                Mon panier
                <span className="pc-badge">{products.length}</span>
              </h1>
            </div>

            {hasProducts && (
              <div className="pc-header-actions">
                <button className="pc-btn-clear" onClick={hundelVidePanier} disabled={clearingCart}>
                  {clearingCart ? (
                    <><i className="bi bi-arrow-repeat" style={{animation:'spin 1s linear infinite'}} /> Vidage...</>
                  ) : (
                    <><i className="bi bi-trash3"></i> Vider</>
                  )}
                </button>
                <Link className="pc-btn-order" to={`/commercials/${MagasinId}/commande`}>
                  <i className="bi bi-box-seam"></i> Suivre commande
                </Link>
              </div>
            )}
          </div>

          {/* ── Alert ── */}
          {message && (
            <div className="pc-alert pc-alert--danger">
              <i className="bi bi-exclamation-triangle-fill"></i> {message}
            </div>
          )}

          {/* ── Content ── */}
          <div className="pc-content">
            {loading ? (
              <div className="pc-empty">
                <div className="pc-empty-icon">
                  <i className="bi bi-arrow-repeat" style={{ animation: "spin 1s linear infinite" }}></i>
                </div>
                <h4>Chargement du panier...</h4>
              </div>
            ) : hasProducts ? (
              <>
                {/* Items */}
                <div className="pc-items-list">
                  {products.map((item, index) => (
                    <div key={item.id || index} className="pc-item">
                      <div className="pc-item-img-wrap">
                        <img
                          src={item.Image || defaultImg}
                          alt={item.Designation}
                          className="pc-item-img"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = defaultImg;
                          }}
                        />
                      </div>

                      <div className="pc-item-info">
                        <h3 className="pc-item-name">{item.Designation}</h3>
                        <span className="pc-item-ref">Réf: {item.RefArticle || item.id}</span>
                        <div className="pc-item-qty-row">
                          <span className="pc-item-qty-label">Qté:</span>
                          <span className="pc-item-qty-value">{item.quantity}</span>
                        </div>
                      </div>

                      <div className="pc-item-right">
                        <div>
                          <span className="pc-item-price">
                            {item.price}
                            <span className="pc-item-currency">MAD</span>
                          </span>
                          {Number(item.quantity) > 1 && (
                            <div className="pc-item-subtotal">
                              {(Number(item.price) * Number(item.quantity)).toFixed(2)} MAD total
                            </div>
                          )}
                        </div>
                        <button
                          className="pc-item-delete"
                          onClick={() => handleDeleteProduct(item.id)}
                          disabled={deletingId === item.id}
                        >
                          {deletingId === item.id ? (
                            <i className="bi bi-arrow-repeat" style={{animation:'spin 1s linear infinite'}} />
                          ) : (
                            <><i className="bi bi-trash3"></i> Supprimer</>
                          )}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Summary Sidebar */}
                <div className="pc-summary">
                  <div className="pc-summary-title">
                    <i className="bi bi-receipt"></i> Résumé de commande
                  </div>

                  <div className="pc-summary-row">
                    <span className="pc-summary-label">Articles ({products.length})</span>
                    <span className="pc-summary-value">{Totale.toFixed(2)} MAD</span>
                  </div>

                  <div className="pc-summary-row">
                    <span className="pc-summary-label">Livraison</span>
                    <span className="pc-summary-value" style={{ color: '#10B981', fontWeight: 600 }}>
                      Gratuite
                    </span>
                  </div>

                  <div className="pc-summary-row">
                    <span className="pc-summary-label">Remise</span>
                    <span className="pc-summary-value">—</span>
                  </div>

                  <div className="pc-summary-total">
                    <span className="pc-summary-total-label">Total</span>
                    <span className="pc-summary-total-value">
                      {Totale.toFixed(2)} <span className="pc-summary-total-currency">MAD</span>
                    </span>
                  </div>

                  <Link className="pc-summary-cta" to={`/commercials/${MagasinId}/commande`}>
                    <i className="bi bi-bag-check"></i> Passer la commande
                  </Link>

                  <div className="pc-summary-secure">
                    <i className="bi bi-shield-check"></i>
                    Paiement sécurisé
                  </div>
                </div>
              </>
            ) : (
              <div className="pc-empty">
                <div className="pc-empty-icon">
                  <i className="bi bi-cart-x"></i>
                </div>
                <h4>Votre panier est vide</h4>
                <p>Parcourez notre catalogue et ajoutez des produits à votre panier.</p>
                <Link className="pc-empty-cta" to={`/commercials/${MagasinId}`}>
                  <i className="bi bi-arrow-left"></i> Continuer mes achats
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
